import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-iscrizione-pagamento-completato',
  standalone: true,
  templateUrl: './pagamento-completato.component.html',
  styleUrl: './pagamento-completato.component.scss',
  imports: [CommonModule, RouterLink],
})
export class IscrizionePagamentoCompletatoComponent implements OnInit {
  private meta = inject(Meta);
  private title = inject(Title);

  ngOnInit() {
    this.title.setTitle('Pagamento Completato - Come Tralci');

    this.meta.updateTag({
      name: 'robots',
      content: 'noindex, nofollow',
    });
  }
}
